"use strict";

function eventize(obj) {
    obj.on = function (e, f) {
        this._events = this._events || {};
        (this._events[e] = this._events[e] || []).push(f);
        return this;
    };

    obj.off = function (e, f) {
        this._events = this._events || {};

        if (e in this._events) {
            if (f) {
                var i = this._events[e].indexOf(f);

                if (i >= 0) {
                    this._events[e].splice(i, 1);
                }
            } else {
                delete this._events[e];
            }
        }

        return this;
    };

    obj.trigger = function (e /* , args... */) {
        if (this._events && e in this._events) {
            var context = this;
            var args = Array.prototype.slice.call(arguments, 1);

            this._events[e].forEach(function (f) {
                f.apply(context, args);
            });
        }

        return this;
    };
}

module.exports = eventize;
